import { SVGProps } from "react";

interface LeftArrowProps extends SVGProps<SVGSVGElement> {
  color?: string; 
}

const LeftArrow = ({ color = "#97A0AF", ...props }: LeftArrowProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    style={{ color }}
    {...props}
  >
    <path
      fill="currentColor" 
      d="m7.1 8 3.9 3.9a.949.949 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.274.948.948 0 0 1-.7-.275L5 8.7a.883.883 0 0 1-.213-.325 1.15 1.15 0 0 1 0-.75A.85.85 0 0 1 5 7.3l4.6-4.6a.948.948 0 0 1 .7-.275c.284 0 .517.092.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7L7.1 8Z"
    />
  </svg>
);

export default LeftArrow;
